export interface Cart {
  cartId: null | string
  expiresAt: number
  items: CartItem[]
  remainingSeconds: number
  totalAmount: string
}

export interface CartCourse {
  format: string
  id: string
  memberPrice: string
  memberPriceGross: null | string
  price: string
  priceGross: null | string
  title: string
  vaNumber: null | string
}

export interface CartDate {
  endDate: null | string
  id: null | string
  isDateRange: boolean
  location: CartLocation | null
  startDate: null | string
  timeRange: null | string
}

export interface CartItem {
  availableExtras: CartOptionGroup[]
  course: CartCourse
  courseDate: CartDate | null
  courseVariant: CartVariant | null
  isMemberPrice: boolean
  isModule: boolean
  itemId: string
  quantity: number
  series: CartSeries | null
  unitPrice: string
}

export interface CartLocation {
  city: string
  name: string
  postalCode: string
  street: string
}

export interface CartOptionChoice {
  id: string
  title: string
}

export interface CartOptionGroup {
  choices: CartOptionChoice[]
  id: string
  isMandatory: boolean
  isSingleChoice: boolean
  title: string
}

export interface CartSeries {
  id: string
  moduleCount: null | number
  modulePosition: null | number
  title: string
}

export interface CartVariant {
  format: string
  id: string
}

export const EMPTY_CART: Cart = { cartId: null, expiresAt: 0, items: [], remainingSeconds: 0, totalAmount: '0.00' }
